import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const SubmitSending = (_props) => (
  <div className="inline-flex flex-row gap-2 relative items-center">
    <div>{_props?.label || 'enviando'}</div>
    <FontAwesomeIcon icon={faSpinner} spin />
  </div>
)

export default SubmitSending
